import CryptoJS from 'crypto-js';
import { CRYPTO_KEY_SOURCE, isDevHost } from '@/lib/appConfig';

const KEY = CryptoJS.SHA256(CRYPTO_KEY_SOURCE);

export function shouldBypassEncryption(): boolean {
  return isDevHost();
}

export function encryptString(plain: string): string {
  if (shouldBypassEncryption()) return plain;
  const iv = CryptoJS.lib.WordArray.random(16);
  const cipher = CryptoJS.AES.encrypt(plain, KEY, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  return ['enc1', iv.toString(CryptoJS.enc.Base64), cipher.ciphertext.toString(CryptoJS.enc.Base64)].join(
    '.',
  );
}

export function isEncryptedPayload(payload: string): boolean {
  return Boolean(payload?.startsWith('enc1.'));
}

export function decryptString(payload: string): string {
  if (shouldBypassEncryption()) return payload;
  if (!payload || !isEncryptedPayload(payload)) return payload;
  const [, ivB64, ctB64] = payload.split('.');
  if (!ivB64 || !ctB64) return payload;
  try {
    const iv = CryptoJS.enc.Base64.parse(ivB64);
    const ct = CryptoJS.enc.Base64.parse(ctB64);
    const decrypted = CryptoJS.AES.decrypt(
      CryptoJS.lib.CipherParams.create({ ciphertext: ct }) as unknown as string,
      KEY,
      { iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 },
    );
    return decrypted.toString(CryptoJS.enc.Utf8);
  } catch {
    return '';
  }
}

export function encryptJson<T>(value: T): string {
  return encryptString(JSON.stringify(value));
}

export function decryptJson<T>(payload: string): T | null {
  try {
    const raw = decryptString(payload);
    return raw ? (JSON.parse(raw) as T) : null;
  } catch {
    return null;
  }
}
